module.exports = __webpack_public_path__ + "static/media/gallery-open.3ada0521.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery-open.svg
// module id = 230
// module chunks = 9